import React from "react";
import PropTypes from "prop-types";
import Layout from "./../../global/Layout";
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import { StyledWrapper, StyledBody, StyledHeading } from "./styles";
import { useHistory } from "react-router-dom";
import NewsletterCompact from "../../components/NewsletterCompact";
import { toggleClientRoot } from "./../toggleClientRoute";

export const SubscribePage = ({ context, clientContext }) => {
  let { isMobile } = clientContext;
  let { data } = context;
  let { page } = data;
  let pageData = page?.items[0];
  const history = useHistory();
  toggleClientRoot();
  if (pageData !== undefined) {
    let body = documentToHtmlString(pageData.fields.body);
    return (
      <Layout
        context={context}
        clientContext={clientContext}
        newsletter={{ showNewsletter: false }}
      >
        <StyledWrapper>
          <StyledBody isMobile={isMobile}>
            {pageData?.fields?.title && (
              <StyledHeading isMobile={isMobile}>
                {pageData.fields.title}
              </StyledHeading>
            )}
            <div
              className="basic-page-body"
              dangerouslySetInnerHTML={{ __html: body }}
            />
            <NewsletterCompact
              clientContext={clientContext}
              context={context}
              submitText="SIGN UP" // @TODO should come from context.data.settings.strings
              dataLabel="SIGN UP" // @TODO should come from context.data.settings.strings
              isMobile={isMobile}
              redirectTo={() => {
                // history.push("/thank-you");
                window.location.replace(`/thank-you`)
              }}
            />
          </StyledBody>
        </StyledWrapper>
      </Layout>
    );
  } else {
    return null;
  }
};

export default SubscribePage;

SubscribePage.propTypes = {
  /**
   Client side variables
  */
  clientContext: PropTypes.object,
  /**
   Server side variables
  */
  context: PropTypes.object.isRequired,
};
